import { useTranslation } from 'react-i18next';
import { Loader2, RefreshCcw, Users as UsersIcon } from 'lucide-react';

interface EmptyEmployeesStateProps {
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

export function EmptyEmployeesState({
  onRefresh,
  isRefreshing = false,
}: EmptyEmployeesStateProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-neutral-300 bg-neutral-50 p-12 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-neutral-200">
        <UsersIcon className="h-8 w-8 text-neutral-500" />
      </div>

      <h3 className="mb-2 text-lg font-semibold text-neutral-900">
        {t('employees.empty.title', 'Aucun employé')}
      </h3>

      <p className="mb-6 max-w-md text-sm text-neutral-600">
        {t(
          'employees.empty.description',
          'Aucun employé trouvé dans ce dossier. Les employés apparaîtront ici après synchronisation avec OpenPaye.'
        )}
      </p>

      {onRefresh && (
        <button
          type="button"
          onClick={onRefresh}
          disabled={isRefreshing}
          className="bg-primary-600 hover:bg-primary-700 inline-flex items-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isRefreshing ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <RefreshCcw className="h-4 w-4" />
          )}
          {isRefreshing
            ? t('folders.sync.syncing', 'Mise à jour...')
            : t('employees.empty.refresh', 'Relire OpenPaye')}
        </button>
      )}
    </div>
  );
}
